var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBathroom = function SvgIconBathroom(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28125 4.45333L7.2399 0.75866C7.23523 0.341191 7.57217 0.000267178 7.98967 0.000239914C9.37427 0.000149495 10.9234 -0.000122506 12.3167 6.38361e-05C12.7752 0.000125164 13.1263 0.408079 13.0553 0.8611C12.4818 4.52422 11.7739 8.16478 11.1111 11.8125H6.47951L6.70673 9.80545H5.6239C4.26874 9.80545 3.0222 9.3823 2.11379 8.61396C1.15375 7.80189 0.625 6.64107 0.625 5.34536V4.45333H7.28125ZM7.49497 10.9205H10.2022C10.8665 7.56045 11.3928 4.19788 12.0455 0.836538H8.2822V5.34536H1.53389C1.53389 7.44618 3.21577 8.91343 5.6239 8.91343H7.72219L7.49497 10.9205Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9688 2.34375H8.21875V1.40625H11.9688V2.34375Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBathroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_bathroom.15c92456.svg";
export { ForwardRef as ReactComponent };